import { ConfigProvider, App as AppAntd } from "antd";
import { theme } from "./constants/theme";
import Routes from "./routes/routes";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./contexts/AuthContext";
import locale from "antd/locale/pt_BR";

const App = () => {
  return (
    <ConfigProvider theme={theme} locale={locale}>
      <AppAntd>
        <AuthContextProvider>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes />
          </BrowserRouter>
        </AuthContextProvider>
      </AppAntd>
    </ConfigProvider>
  );
};

export default App;
